/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiPlanMatrixRow } from "@/types/strapi";

import { Spacing } from "@/tokens/spacing";

import { GridColumn } from "@/ui/atoms/grid_column";
import { GridContainer } from "@/ui/atoms/grid_container";
import { SubgridContainer } from "@/ui/atoms/subgrid_container";
import { Text } from "@/ui/atoms/text";
import { SmallViewportPricingCategory } from "@/ui/wrappers/plan_matrix";
import { PricingPlansMatrixRow } from "@/ui/wrappers/pricing_plans_matrix_row";

interface PricingPlanMatrixProps {
    currentPlanCategory: SmallViewportPricingCategory;
    Plan_Matrix_Rows?: StrapiPlanMatrixRow[];
    shouldShowFullMatrix: boolean;
    Title: string;
}

export const PricingPlansMatrix: FunctionComponent<PricingPlanMatrixProps> = (
    props,
) => {
    /**
     * Styles
     */
    const matrixCategoryContainerStyles = css({
        padding: `${Spacing["spacing-8"]} 0`,
    });

    /**
     * Rendering
     */
    return (
        <>
            <GridContainer className={matrixCategoryContainerStyles}>
                <Text
                    columnSpan="full"
                    columnStart={1}
                    fontSize="PlanCardPrice"
                    marginBottom="None"
                    tag="h3"
                >
                    {props.Title}
                </Text>
            </GridContainer>

            {props.Plan_Matrix_Rows &&
                props.Plan_Matrix_Rows.map((_matrixRow, _rowIndex, _arr) => {
                    return (
                        <SubgridContainer
                            key={`pricing-plan-matrix-row::${_rowIndex}`}
                        >
                            <GridColumn columnSpan="full" columnStart={1}>
                                <PricingPlansMatrixRow
                                    {..._matrixRow}
                                    currentPlanCategory={
                                        props.currentPlanCategory
                                    }
                                    isFirstRow={_rowIndex === 0}
                                    isLastRow={_rowIndex === _arr.length - 1}
                                    shouldShowFullMatrix={
                                        props.shouldShowFullMatrix
                                    }
                                />
                            </GridColumn>
                        </SubgridContainer>
                    );
                })}
        </>
    );
};
